import { render } from "./companySearch.vue?vue&type=template&id=bb81a0b4&scoped=true"
import script from "./companySearch.vue?vue&type=script&lang=js"
export * from "./companySearch.vue?vue&type=script&lang=js"

import "./companySearch.vue?vue&type=style&index=0&id=bb81a0b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bb81a0b4"

export default script